import React from "react";

import DashboardRoundedIcon from "@material-ui/icons/DashboardRounded";
import SwapHorizRoundedIcon from "@material-ui/icons/SwapHorizRounded";
import { AllInboxRounded } from "@material-ui/icons";
import { ReactComponent as ListingsIcon } from "../../../assets/images/bottomNavigation/listings.svg";
import { is_empty } from "utils/validations";
import { api } from "data";
import { RESOURCE_KEYS, orgPermissions } from "utils/OrgPermissions";
import {
  DASHBOARD_CONFIG,
  LISTING_CONFIG,
  TRANSACTIONS_CONFIG,
  INBOX_CONFIG,
} from "features/UILayout/modules/Menu/constants/Menu.constants";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import { getS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";

const QuickLinksIcon = () => (
  <ExlyImage
    src={getS3AssetCDNUrl("assets/vectors/dashboard/quick_links.svg")}
  />
);

const defaultTabs = [
  {
    label: "Shortcuts",
    icon: <QuickLinksIcon />,
    path: "/whats-next",
  },
  {
    label: "Offerings",
    icon: <ListingsIcon className="menu-item-selected" />,
    path: "/ScheduleList",
    ...LISTING_CONFIG,
  },
  {
    label: "Dashboard",
    icon: <DashboardRoundedIcon />,
    path: "/Dashboard",
    ...DASHBOARD_CONFIG,
  },
  {
    label: "Transactions",
    icon: <SwapHorizRoundedIcon />,
    path: `/${api.transaction_list}`,
    ...TRANSACTIONS_CONFIG,
  },
  {
    label: "Inbox",
    icon: <AllInboxRounded />,
    path: "/communications/inbox",
    ...INBOX_CONFIG,
  },
];

export const getTabConfig = (permissions) => {
  if (is_empty(permissions)) return defaultTabs;

  const hideListings = permissions["create_edit_listing"];
  const hideDashboard = permissions["dashboard"];

  const hideInbox = permissions["inbox"];

  const hideTransactions =
    permissions["manage_transactions"] &&
    is_empty(permissions["manage_transactions"]);
  const isAllTransactionHidden = orgPermissions.isNavigationItemHidden(
    RESOURCE_KEYS.SUBSECTIONS.MANAGE_TRANSACTIONS.ALL_TRANSACTIONS
  );

  const tabs = [
    {
      label: "Shortcuts",
      icon: <QuickLinksIcon />,
      path: "/whats-next",
    },
    {
      label: "Listings",
      icon: <ListingsIcon className="menu-item-selected" />,
      path: "/ScheduleList",
      hidden: hideListings,
      ...LISTING_CONFIG,
    },
    {
      label: "Dashboard",
      icon: <DashboardRoundedIcon />,
      path: "/Dashboard",
      hidden: hideDashboard,
      ...DASHBOARD_CONFIG,
    },
    {
      label: "Transactions",
      icon: <SwapHorizRoundedIcon />,
      path: isAllTransactionHidden
        ? `/${api.manage_subscriptions_list}`
        : `/${api.transaction_list}`,
      hidden: hideTransactions,
      ...TRANSACTIONS_CONFIG,
    },
    {
      label: "Inbox",
      icon: <AllInboxRounded />,
      path: "/communications/inbox",
      hidden: hideInbox,
      ...INBOX_CONFIG,
    },
  ];

  return tabs.filter((tab) => !tab.hidden);
};
